import React, {createRef, useContext, useState} from 'react';
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import {MenuItem, Select, TablePagination, useTheme} from "@material-ui/core";
import __ from "lodash";

import SystemContext from "../../../SystemContext";
import {formatEmailInput} from "../../../functions/EmailValidation";
import {MaskedText} from "../../../controls";
import {ColumnWidth, ValidatorColumn} from "../../../blocks/ColumnHelper";
import ContactMethodsValidator from "../validators/ContactMethodsValidator";
import { defaultComponents } from '../../../controls/Material-Table-Components';


// const extractContacts = (contactMethods) => {
//   const methods = [];
//   if (contactMethods && Array.isArray(contactMethods)) {
//     contactMethods.forEach(contactMethod => {
//       Object.keys(contactMethod).forEach(function (key) {
//         methods.push({
//           contactMethod: key,
//           contactValue: contactMethod[key],
//         });
//       });
//     })
//   }
//   return methods;
// }

const formatValue = (type, value) => {

  if (type === "Email" && value)
    return(formatEmailInput(value));
  return value;
}

const ContactMethods = (_props) => {
  const {isAuthenticated} = useAuth0();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const props = {
    canEdit: true,
    ..._props
  }
  const [state, setState] = useState({
    canEdit: props.canEdit,
    contacts: props.extractContacts(props.contactMethods)
  });

  const tableRef = createRef({state: {lastEditingRow: false}});

  const contactMethods = SystemData.contactMethods;

  const getContactColumns = (props) => {
    const baseColumn = {
      cellStyle: {padding: "8px 2px"},
      headerStyle: {padding: "8px 2px"},
      editable: props.canEdit ? "always" : "never",
      emptyValue: "",
      initialEditValue: "",
    };

    const formatChars = {
      "U": "[A-Z]",
      "A": "[A-Z0-9]",
      "a": "[A-Za-z0-9]",
      "9": "[0-9]",
      "D": "[0-9.]",
      "-": "-",
      "x": "."
    }

    const defaultEditProps = {
      style: {fontSize: "0.875rem"}
    };

    //const additionalValues = {route: tripRoute};
    const validatorColumn = ValidatorColumn(ContactMethodsValidator, false);

    return [
       {...validatorColumn},

      {
        ...ColumnWidth(150),
        ...baseColumn,
        title: "Contact Method",
        field: "contactMethod",
        editable: props.canEdit ? "always" : "never",
        initialEditValue: contactMethods[0],
        editComponent: (props) => (
          <Select
            labelId="Contact Method"
            id="Contact Method"
            value={props.value}
            onChange={e => {
              props.onChange(e.target.value);
            }}
          >
            {contactMethods.map((item) => {
              return (<MenuItem key={item} value={item}>{item}</MenuItem>);
            })
            }
          </Select>
        ),
        render: (rowData) => (<div>{rowData.contactMethod}</div>),
      },
      {
        ...baseColumn,

        title: "Value",
        field: "contactValue",
        initialEditValue: "",
        editable: props.canEdit ? "always" : "never",
        editComponent: (props) => (
          <MaskedText
            mask={"x".repeat(100)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            forceUpperCase={false}
            defaultValue={""}
            value={props.value}
            onChange={(value) => {
              props.onChange(formatValue(props.rowData.contactMethod, value));
            }}
            inputProps={{style: {fontSize: "0.875rem"}}}
          />
        ),
      },

    ];
  };

  const updateParent = (contactMethods) => {
    const methods = [];

    if (contactMethods) {
      contactMethods.forEach(method => {
        const methodObject = {}
        methodObject[method.contactMethod.toLowerCase()] = method.contactValue;
        methods.push(methodObject);
      })
    }
    props.onChange(methods);
  }

  return (isAuthenticated &&
    <div style={{marginLeft: 50,}}>
      <MaterialTable
        tableRef={tableRef}
        style={{
          backgroundColor: "#fdfdfd",
          border: "2px solid #aaaaaa",
          boxShadow: "none",
          borderRadius: 0,
        }}
        options={{
          addRowPosition: "first",
          actionsColumnIndex: -1,
          cellStyle: {
            padding: "8px 2px",
          },
          headerStyle: {
            backgroundColor: theme.palette.childTableHeader.backgroundColor,
            color: theme.palette.childTableHeader.textColor,
            padding: "2px",
          },
          toolbarButtonAlignment: "right",
          pageSize: 5,
          detailPanelType: "single",
          //header: false,
          padding: "dense",
          search: false,
          showTitle: false,
          toolbar: state.contacts.length === 0 ? true : false,
        }}
        components={{
          ...defaultComponents,
          Pagination: (props) => (
            <TablePagination
              {...props}
              rowsPerPageOptions={[5, 10, 15]}
            />
          ),
        }}
        title="Contact Details"
        columns={getContactColumns({canEdit: state.canEdit})}
        data={state.contacts}
        actions={
          [
            {
              icon: "add",
              tooltip: "Add Contact Method",
              onClick: () => {
                tableRef.current.setState({ showAddRow: !tableRef.current.state.showAddRow })
              },
            },
          ]
        }
        editable={{
          isEditable: () => {
            return state.canEdit;
          },
          isDeletable: () => {
            return state.canEdit;
          },
          onRowAdd: state.canEdit
            ? (newData) => new Promise((resolve, reject) => {
              resolve();
              const contacts = [...state.contacts];
              contacts.push(newData);
              setState({...state, contacts});
              updateParent(contacts);
            })
            : undefined,
          onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
              resolve();
              const contacts = [...state.contacts];
              const lineIdx = __.findIndex(contacts, (trip) => {
                const newRecord = __.omit(trip, ["tableData"]);
                const oldRecord = __.omit(oldData, ["tableData"]);
                return __.isEqual(newRecord, oldRecord);
              });
              contacts[lineIdx] = newData;
              setState({...state, contacts});
              updateParent(contacts);
            }),
          onRowDelete: (oldData) =>
            new Promise((resolve, reject) => {
              resolve();
              const contacts = [...state.contacts];
              const lineIdx = __.findIndex(contacts, (trip) => {
                const newRecord = __.omit(trip, ["tableData"]);
                const oldRecord = __.omit(oldData, ["tableData"]);
                return __.isEqual(newRecord, oldRecord);
              });
              contacts.splice(lineIdx, 1);
              setState({...state, contacts});
              updateParent(contacts);
            }),
        }}
      />
    </div>
  );

}

export default ContactMethods;
